import { render, staticRenderFns } from "./DomainHistoryList.vue?vue&type=template&id=0e24aa18"
import script from "./DomainHistoryList.vue?vue&type=script&lang=js"
export * from "./DomainHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports